import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,I_COMMON_GET_ITEM_PARAMS,_customFetch} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- LOGIN MICROSOFT
// ---------------------------------

const ENDPOINT_MICROSOFT = '/saml';

const logger = LoggerService.getInstance();


/**
 * Requete le endpoint
 * Récupère l'URL de connexion Microsoft (step 1)
 * @param param0
 */
const getLink = async ():Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - microsoft - getLink1...'));
  const params = {
    method: 'GET',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
    },
  };
  const URL = `${ENDPOINT_MICROSOFT}/link-microsoft${APP_CONFIG.ENDPOINT_SUFFIX}?redirect_uri=${window.location.origin}`;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint
 * Envoie les infos de connexion Microsoft au back, récupère les token
 * @param param0
 */
const connect = async ({
  code,
  session_state,
  state,
  client_info,
  redirect_uri,
}:{
  code:string,
  session_state:string,
  state:string,
  client_info:string,
  redirect_uri:string,
}):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - microsoft - connect...'));
  const params = {
    method: 'GET',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
    },
  };
  const URL = `${ENDPOINT_MICROSOFT}/login${APP_CONFIG.ENDPOINT_SUFFIX}?code=${code}&session_state=${session_state}&state=${state}&client_info=${client_info}&redirect_uri=${redirect_uri}`;
  return _customFetch(URL,params);
};

const microsoftEndpoints = {
  getLink,
  connect,
};

export default microsoftEndpoints;
